import { render, staticRenderFns } from "./BeneficiosComercio.vue?vue&type=template&id=38c27edf&"
import script from "./BeneficiosComercio.vue?vue&type=script&lang=js&"
export * from "./BeneficiosComercio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports